import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';

import { ClickFormsExportRow } from './types.ts';

export function fillInBlankRows(filledRows: ClickFormsExportRow[], totalRows: number): string {
  let result = '';
  let i = 1;
  // First sort the rows by the row number
  filledRows
    .sort((a, b) => a.row - b.row)
    .forEach((filledRow) => {
      while (i < filledRow.row) {
        result = `${result}\n`;
        i++;
      }
      result = `${result}${filledRow.value ?? ''}\n`;
      i++;
    });

  while (i <= totalRows) {
    result = `${result}\n`;
    i++;
  }

  return result;
}

export function formatAdjustmentString(price: AloftPrice | undefined): string {
  if (isUndefined(price)) {
    return '';
  }
  const dollarAmount = price.roundToDollarLike().toDollarLike();

  const sign = dollarAmount > 0 ? '+' : '';
  return `${sign}${dollarAmount.toLocaleString('en-US')}`;
}
